import {create} from 'zustand';
import {persist} from 'zustand/middleware';

interface BuyCoinsStore {
  url: string | null;
  setURL: (url: string) => void;
  clearURL: () => void;
}

const initialValues = {
  url: null,
};

export const usePaymentInitiator = create<BuyCoinsStore>()(
  persist(
    (set) => ({
      ...initialValues,
      setURL: (url) => set({url}),
      clearURL: () => set({url: null}),
    }),
    {
      name: 'payment-initiator',
    },
  ),
);
